import React from 'react';
import type { ReactChildren } from '@fluentui/react-northstar';
import { Page } from './Container.style';
import {
    useStyles,
    Container as ClampContainer,
    useTheme,
} from '@archipro-design/aria';

interface ProjectContainerProps {
    children: ReactChildren;
}

const Container = ({ children }: ProjectContainerProps) => {
    const { css } = useStyles();
    const theme = useTheme();
    return (
        <div
            style={{ backgroundColor: theme.siteVariables.bodyBackground }}
            className={css(Page)}
        >
            <ClampContainer>{children}</ClampContainer>
        </div>
    );
};

export default Container;
